import { render, staticRenderFns } from "./BlogDetails.vue?vue&type=template&id=79c40d88&scoped=true&"
import script from "./BlogDetails.vue?vue&type=script&lang=js&"
export * from "./BlogDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetails.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BlogDetails.vue?vue&type=style&index=1&id=79c40d88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c40d88",
  null
  
)

export default component.exports